import { useEffect } from "react";
import { Flame, X } from "lucide-react";

const BLESSINGS = {
  7: {
    title: "Seven days kept",
    line: "A full week of returning to the light. What you tend daily begins to tend you.",
    verse: "“Ask, and it shall be given you; seek, and ye shall find.” — Matthew 7:7",
  },
  30: {
    title: "Thirty days kept",
    line: "A month of faithfulness. The small root, watered daily, is quietly becoming a tree.",
    verse: "“The kingdom of God... groweth up... and becometh greater than all herbs.” — Mark 4:31-32",
  },
  100: {
    title: "One hundred days kept",
    line: "A hundred days of devotion. You are no longer visiting this path — you are walking it.",
    verse: "“Well done, thou good and faithful servant.” — Matthew 25:21",
  },
};

export default function MilestoneCelebration({ milestone, onClose }) {
  useEffect(() => {
    if (!milestone) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [milestone, onClose]);

  if (!milestone || !BLESSINGS[milestone]) return null;
  const b = BLESSINGS[milestone];

  return (
    <div
      data-testid="milestone-celebration"
      className="fixed inset-0 z-[100] grid place-items-center px-6"
      style={{ background: "rgba(10,7,14,0.82)", backdropFilter: "blur(6px)" }}
      onClick={onClose}
    >
      <div
        className="relative max-w-lg w-full glass rounded-3xl p-10 text-center gold-glow border border-[#D4AF37]/40"
        style={{ animation: "fadeUp 0.5s ease both" }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          data-testid="milestone-close"
          onClick={onClose}
          className="absolute top-4 right-4 text-[#A8A29E] hover:text-[#F5F1E7] transition-colors duration-300"
        >
          <X size={20} />
        </button>
        <div className="mx-auto h-20 w-20 rounded-full bg-[#D4AF37]/10 grid place-items-center text-[#D4AF37]">
          <Flame size={40} />
        </div>
        <p className="mt-6 serif text-6xl text-[#D4AF37]" data-testid="milestone-number">{milestone}</p>
        <h2 className="mt-2 serif text-3xl text-[#F5F1E7]">{b.title}</h2>
        <p className="mt-4 text-[#A8A29E] leading-relaxed text-lg">{b.line}</p>
        <p className="mt-6 italic-serif text-[#C1272D] text-lg leading-relaxed">{b.verse}</p>
        <button
          data-testid="milestone-continue"
          onClick={onClose}
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#D4AF37] text-[#110D14] px-8 py-3 font-medium hover:bg-[#e6c860] transition-colors duration-300"
        >
          Keep going
        </button>
      </div>
    </div>
  );
}

export const MILESTONES = [7, 30, 100];
